import './index.scss'
import React, { useEffect } from 'react'
import CoinSvg from './images/points-coin.svg?react'
import {
  vipKindToThemeKey,
  computeUsageState,
  buildEntrySegments,
  DEFAULT_ENTRY_PER_QUERY_COST
} from './config'
import type { PointsEntryChipProps, PointsEntryContext } from './types'

/**
 * 积分入口条（紧凑胶囊，通用公共组件）。
 *
 * 按身份 + 用量展示 4 状态文案（满额 / 一般 / 预警 / 不足 1 次），关键数字橙色高亮、
 * 升级 / 增购 CTA 蓝色。预警 / 不足 1 次态整条可点（走 onCtaClick）。
 */
const PointsEntryChip: React.FC<PointsEntryChipProps> = ({
  vipKind,
  total,
  used,
  perQueryCost = DEFAULT_ENTRY_PER_QUERY_COST,
  onCtaClick,
  onClick,
  onExpose,
  className
}) => {
  const safeTotal = Math.max(0, total || 0)
  const safeUsed = Math.min(Math.max(0, used || 0), safeTotal)
  const remaining = Math.max(0, safeTotal - safeUsed)

  const themeKey = vipKindToThemeKey(vipKind)
  const usageState = computeUsageState(safeTotal, safeUsed, perQueryCost)
  const segments = buildEntrySegments(
    themeKey,
    usageState,
    safeTotal,
    safeUsed,
    perQueryCost
  )
  const hasCta = segments.some((s) => s.type === 'cta')
  const clickable = hasCta || !!onClick

  const action: 'upgrade' | 'addon' = themeKey === 'super' ? 'addon' : 'upgrade'
  const ctx: PointsEntryContext = {
    vipKind,
    themeKey,
    usageState,
    action,
    total: safeTotal,
    used: safeUsed,
    remaining
  }

  // 曝光埋点：首次渲染触发一次
  useEffect(() => {
    if (onExpose) onExpose(ctx)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClick = () => {
    if (hasCta) {
      if (onCtaClick) onCtaClick(ctx)
    } else if (onClick) {
      onClick(ctx)
    }
  }

  return (
    <div
      className={`points-entry-chip${clickable ? ' clickable' : ''}${
        className ? ` ${className}` : ''
      }`}
      onClick={handleClick}
    >
      <CoinSvg className="pec-icon" aria-hidden="true" />
      <span className="pec-content">
        {segments.map((s, i) => (
          <span key={i} className={`pec-${s.type}`}>
            {s.text}
          </span>
        ))}
      </span>
    </div>
  )
}

export default PointsEntryChip
